export class AccountOwnerDetailModel {
    public companyId: number;
    public name: string;
    public email: string;
    public phone: string;
}
